import { useEffect, useState } from 'react';
import { RemoveScroll } from 'react-remove-scroll';
import { Portal } from '@radix-ui/react-portal';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import isEmpty from 'lodash-es/isEmpty';

import { getAuthBearerValue, getWebStoreApiClient } from '@gn-audio/jss-core';

import { isBlueparrottFromContext } from '../../utils';
import Backdrop from '../Backdrop/Backdrop';
import { JabraLoader } from '../JabraLoader/JabraLoader';
import { ClientLocationProvider } from '../MegaMenu/providers/ClientLocationContext';
import { useBasket } from './BasketContext/useBasket';
import Checkout from './common/Checkout';
import Empty from './common/Empty';
import Header from './common/Header';
import MyAccount from './common/MyAccount';

import styles from './Basket.module.css';

const Basket = (): React.JSX.Element | null => {
  const {
    isBasketOpen,
    isEmailCartOpen,
    closeBasket,
    toggleEmailCart,
    busy,
    basket,
    isMyAccountViewOpen,
  } = useBasket();

  const { sitecoreContext } = useSitecoreContext();
  const isBlueparrott = isBlueparrottFromContext(sitecoreContext);

  const isBasketEmpty = isEmpty(basket?.product_items);
  const [token, setToken] = useState<string>('');

  useEffect(() => {
    const getToken = async () => {
      try {
        const client = getWebStoreApiClient();
        const result = await client.onTokenAcquired;
        if (result) {
          const token = getAuthBearerValue(result);
          setToken(token);
        }
      } catch (error) {
        console.error(error);
      }
    };
    getToken();
  }, []);

  return (
    <RemoveScroll enabled={isBasketOpen} allowPinchZoom>
      <Portal>
        <ClientLocationProvider>
          <div
            role="dialog"
            aria-labelledby="modal_basket_title"
            aria-modal={true}
            data-brand={isBlueparrott ? 'blueparrott' : 'jabra'}
          >
            <div
              className={`fixed right-0 top-0 z-50 flex h-[100dvh] bg-white transition-transform duration-500 max-md:w-[90vw] md:w-[32rem]`}
              style={{
                transform: `translateX(${isBasketOpen ? '0' : '100%'})`,
              }}
            >
              {busy && <JabraLoader />}
              <div className={styles.innerContainer}>
                <Header />
                <div className={styles.body}>
                  {isBasketEmpty ? (
                    <Empty />
                  ) : isMyAccountViewOpen ? (
                    <div className="absolute z-10 flex h-full w-full flex-col items-center justify-center bg-white duration-500 ease-in-out animate-in slide-in-from-right-full">
                      <MyAccount token={token} />
                    </div>
                  ) : (
                    <Checkout
                      className="duration-500 ease-in-out animate-in slide-in-from-left-full"
                      token={token}
                    />
                  )}
                </div>
                <Backdrop onClick={toggleEmailCart} isVisible={isEmailCartOpen} />
              </div>
            </div>

            <Backdrop onClick={closeBasket} isVisible={isBasketOpen} />
          </div>
        </ClientLocationProvider>
      </Portal>
    </RemoveScroll>
  );
};

export default Basket;
